import { createSelector } from 'reselect';
import { IDENTIFY, GROUP, RESET } from '../store/middleware/segment';
import { session as sessionSelector } from './session';

export const identify = createSelector(sessionSelector, session => {
  if (!session) return null;
  const { userID: userId, email, username } = session;
  return {
    type: IDENTIFY,
    payload: {
      userId,
      traits: {
        email,
        username
      }
    }
  };
});

export const group = createSelector(sessionSelector, session => {
  if (!session) return null;
  const { teamName: groupId } = session;
  return {
    type: GROUP,
    payload: { groupId }
  };
});

export const reset = createSelector(
  sessionSelector,
  session => (session ? null : { type: RESET })
);



// WEBPACK FOOTER //
// ./js/selectors/analytics.js